import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.entries";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.set";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.pad-start";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _slicedToArray from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _typeof from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/typeof";
import { Message } from "element-ui";
export default {
  // 统一单位转换
  conversion: function conversion(num) {
    return Number(num) / 100;
  },
  textRepl: function textRepl(str) {
    var reple = process.env.VUE_APP_IMAGEURLRPLE;
    var url = process.env.VUE_APP_IMAGEURL;
    var newstr = reple ? str.replaceAll(reple, url + reple) : str;
    return newstr;
  },
  // 全路径使用
  Fullpath: function Fullpath(str) {
    var url = process.env.VUE_APP_IMAGEURL;
    return str.indexOf(process.env.VUE_APP_IMAGEURL) > -1 ? str : url + str;
  },
  imgTrow: function imgTrow(str) {
    var url = process.env.VUE_APP_IMAGEURL;
    return url + str;
  },
  capy: function capy(text) {
    //创建一个input框
    var input = document.createElement("input"); //将指定的DOM节点添加到body的末尾

    document.body.appendChild(input); //设置input框的value值为直播地址

    input.setAttribute("value", text); //选取文本域中的内容

    input.select(); //copy的意思是拷贝当前选中内容到剪贴板
    //document.execCommand（）方法操纵可编辑内容区域的元素
    //返回值为一个Boolean，如果是 false 则表示操作不被支持或未被启用

    if (document.execCommand("copy")) {
      document.execCommand("copy");
    } //删除这个节点


    document.body.removeChild(input);
    Message.success("复制成功");
  },
  checkObjectKeys: function checkObjectKeys(obj) {
    var _this = this;

    if (_typeof(obj) !== "object" || obj === null || Array.isArray(obj)) {
      return obj;
    }

    var seen = new Set();
    var newObj = {};
    Object.keys(obj).forEach(function (key) {
      if (seen.has(key)) {// this.$message.error('不能输入相同的键值对')
      }

      seen.add(key);
      var value = obj[key];
      newObj[key] = _this.checkObjectKeys(value);
    });
    return newObj;
  },
  mergeData: function mergeData(paramsData) {
    var _this2 = this;

    try {
      if (!Array.isArray(paramsData)) {
        throw new Error("Input must be an array");
      }

      var result = {};
      var seenKeys = new Set();
      paramsData.forEach(function (item) {
        if (_typeof(item) !== "object" || item === null || Array.isArray(item)) {
          throw new Error("Item must be a non-null object");
        }

        Object.keys(item).forEach(function (key) {
          if (seenKeys.has(key)) {// this.$message.error('不能输入相同的键值对')
          }

          seenKeys.add(key);
          result[key] = _this2.checkObjectKeys(item[key]);
        });
      });
      return result;
    } catch (err) {
      return null;
    }
  },
  transformObject: function transformObject(inputObj) {
    var result = [];

    for (var key in inputObj) {
      var value = inputObj[key];
      var type = this.getType(value);

      switch (type) {
        case 'string':
          result.push({
            typeValue: 'string',
            stringKey: key,
            stringVal: value
          });
          break;

        case 'number':
          result.push({
            typeValue: 'number',
            numberKey: key,
            numberVal: value
          });
          break;

        case 'boolean':
          result.push({
            typeValue: 'boolean',
            booleanKey: key,
            booleanVal: value
          });
          break;

        case 'map':
          result.push({
            typeValue: 'map',
            mapParams: key,
            mapData: this.objectToKeyValueArray(value)
          });
          break;

        case 'array':
          result.push({
            typeValue: 'array',
            arrayParams: key,
            arrayData: this.transformArrayItems(value)
          });
          break;
      }
    }

    return result;
  },
  // 辅助函数：判断类型
  getType: function getType(value) {
    if (Array.isArray(value)) return 'array';
    if (_typeof(value) === 'object' && value !== null) return 'map';
    if (typeof value === 'number' && value !== null) return 'number';
    if (typeof value === 'boolean' && value !== null) return 'boolean';

    if (typeof value === 'string') {
      if (!isNaN(value) && value.trim() !== '') return 'number';
      if (value.toLowerCase() === 'true' || value.toLowerCase() === 'false') return 'boolean';
      return 'string';
    }
  },
  // 辅助函数：对象转key-value数组
  objectToKeyValueArray: function objectToKeyValueArray(obj) {
    return Object.keys(obj).map(function (key) {
      return {
        key: key,
        value: obj[key]
      };
    });
  },
  // 辅助函数：处理数组项
  transformArrayItems: function transformArrayItems(arr) {
    var _this3 = this;

    return arr.map(function (item) {
      if (_typeof(item) === 'object' && item !== null) {
        return {
          arrChildrenItem: _this3.objectToKeyValueArray(item)
        };
      }

      return {
        arrChildrenItem: [{
          key: 'value',
          value: item
        }]
      };
    });
  },
  formatFileSize: function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    var units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    var i = Math.floor(Math.log(bytes) / Math.log(1024));
    return "".concat((bytes / Math.pow(1024, i)).toFixed(2), " ").concat(units[i]);
  },
  dealTypeData: function dealTypeData(arrayDataList) {
    arrayDataList.forEach(function (item) {
      if (item.typeValue == "string") {
        ["arrayData", "arrayParams", "mapData", "mapParams", "numberKey", "numberVal", "booleanKey", "booleanVal"].forEach(function (a) {
          delete item[a];
        });
        item[item.stringKey] = item.stringVal;
        delete item.stringKey;
        delete item.stringVal;
        delete item.typeValue;
      } else if (item.typeValue == "map") {
        ["arrayData", "arrayParams", "stringKey", "stringVal", "numberKey", "numberVal", "booleanKey", "booleanVal"].forEach(function (a) {
          delete item[a];
        });
        var newData = {};
        item.mapData.forEach(function (_ref) {
          var key = _ref.key,
              value = _ref.value;
          newData[key] = value;
        });
        item[item.mapParams] = newData;
        delete item.mapParams;
        delete item.mapData;
        delete item.typeValue;
      } else if (item.typeValue == "array") {
        ["stringKey", "stringVal", "mapData", "mapParams", "numberKey", "numberVal", "booleanKey", "booleanVal"].forEach(function (a) {
          delete item[a];
        });

        var convert = function convert(obj) {
          var convertedArray = obj.arrayData.map(function (item) {
            return item.arrChildrenItem.reduce(function (acc, _ref2) {
              var key = _ref2.key,
                  value = _ref2.value;
              acc[key] = value;
              return acc;
            }, {});
          });
          return convertedArray;
        };

        item[item.arrayParams] = convert(item);
        delete item.arrayData;
        delete item.arrayParams;
        delete item.typeValue;
      } else if (item.typeValue == "number") {
        ["arrayData", "arrayParams", "mapData", "mapParams", "stringKey", "stringVal", "booleanKey", "booleanVal"].forEach(function (a) {
          delete item[a];
        });
        item[item.numberKey] = item.numberVal;
        delete item.numberKey;
        delete item.numberVal;
        delete item.typeValue;
      } else if (item.typeValue == "boolean") {
        ["arrayData", "arrayParams", "mapData", "mapParams", "stringKey", "stringVal", "numberKey", "numberVal"].forEach(function (a) {
          delete item[a];
        });
        item[item.booleanKey] = item.booleanVal;
        delete item.booleanKey;
        delete item.booleanVal;
        delete item.typeValue;
      }
    });
    return arrayDataList;
  },
  convertFormat: function convertFormat(data) {
    return data.map(function (item) {
      var _ref3;

      var channel_params = {};
      item.arrayData.forEach(function (param) {
        channel_params[param.key] = param.value;
      });
      return _ref3 = {}, _defineProperty(_ref3, item.reportKey, item.reportVal), _defineProperty(_ref3, "channel_params", JSON.stringify(channel_params)), _ref3;
    });
  },
  convertToOriginalFormat: function convertToOriginalFormat(data) {
    return data.map(function (item) {
      // 获取动态的reportKey（第一个非channel_params的键）
      var keys = Object.keys(item).filter(function (key) {
        return key !== 'channel_params';
      });
      var reportKey = keys[0];
      var reportVal = item[reportKey]; // 转换channel_params为arrayData格式

      var arrayData = Object.entries(JSON.parse(item.channel_params) || {}).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            value = _ref5[1];

        return {
          key: key,
          value: value
        };
      });
      return {
        arrayData: arrayData,
        reportKey: reportKey,
        reportVal: reportVal
      };
    });
  },
  formatDuration: function formatDuration(rawTime) {
    if (rawTime === null || rawTime === undefined || isNaN(rawTime)) return '--:--.--';
    var totalMs = Math.round(Number(rawTime) * 1000); // 第二步：根据毫秒个位数四舍五入到两位小数（单位：厘秒，即 1/100 秒）
    // 例: (12012 + 5) // 10 = 12017 // 10 = 1201

    var centiseconds = Math.floor((totalMs + 5) / 10); // 第三步：还原为秒
    // 例: 1201 / 100 = 12.01 秒

    var processedTime = centiseconds / 100; // 1. 分 = 原始时间 / 60 取商 

    var minutes = Math.floor(processedTime / 60); // 2. 整数秒 = 原始时间 % 60 取余 

    var seconds = Math.floor(processedTime % 60); // 3. 核心修改：先乘以 100 丢弃两位以后的小数，再对 100 取余得到 00-99 的百毫秒/十毫秒值
    // 这样 107.14984893799 会变成 10714，取余 100 后得到 14，完美避开四舍五入

    var hundredthsOfSecond = Math.floor(processedTime * 100) % 100;
    var showMin = minutes;
    var showSec = String(seconds).padStart(2, '0');
    var showMs = String(hundredthsOfSecond).padStart(2, '0');
    return "".concat(showMin, ":").concat(showSec, ".").concat(showMs);
  },
  parseDuration: function parseDuration(str) {
    if (!str || typeof str !== 'string') return str;
    var durationStr = str.trim(); // 如果包含冒号，说明是 "分:秒" 格式

    if (durationStr.includes(':')) {
      var parts = durationStr.split(':');

      if (parts.length === 2) {
        var minutes = parseFloat(parts[0]) || 0;
        var seconds = parseFloat(parts[1]) || 0; // 核心逆向算法：总秒数 = 分钟 * 60 + 秒数
        // 使用 toFixed(2) 防止 JS 浮点数精度丢失，再转回 float

        return parseFloat((minutes * 60 + seconds).toFixed(2));
      }
    } // 如果不包含冒号，说明本身就是纯数字字符串，直接转浮点数


    return parseFloat(durationStr);
  }
};